<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/team/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('banzubianhao')">
            <el-input v-model="yt.conditions.teamNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('banzumingcheng')">
            <el-input v-model="yt.conditions.teamName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :ids.sync="yt.conditions.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary" v-if="utils.checkPower('web_employment_management_team_add_button')">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" :loading="exportLoading" @click="yt.showEditDialog('daorubanzurenyuan', null, '1300px')" v-if="utils.checkPower('web_employment_management_team_member_import')">
          {{ $t('daorubanzurenyuan') }}
        </el-button>
        <el-button size="mini" :loading="exportLoading" @click="exportExcel()" v-if="utils.checkPower('web_employment_management_team_member_export')">
          {{ $t('daochubanzurenyuan') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作列 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="utils.checkPower('web_employment_management_team_member_button')">
            <el-button type="text" @click="yt.showEditDialog('banzurenyuan', scope.row, 'w2')">
              {{ $t('banzurenyuan') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_employment_management_team_update_button')">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1')">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_employment_management_team_delete_button')">
            <el-popconfirm title="是否确认删除班组？删除后可能造成基础数据缺失" confirm-button-text="是" cancelButtonText="否" @confirm="deleteRecord(scope.row)">
              <el-button type="text" class="font-color-danger" slot="reference" :loading="loading">{{ $t('shanchu') }}</el-button>
            </el-popconfirm>
          </el-col>
        </el-row>
      </template>

      <template #banzuzuzhang="scope">
        {{ getLeaderName(scope.row.attribute1) }}
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增或编辑 -->
      <template v-if="yt.editObj.action == 'xinzeng' || yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('banzubianhao')" required>
            <el-input v-model="yt.editObj.teamNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('banzumingcheng')" required>
            <el-input v-model="yt.editObj.teamName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')" required>
            <yi_data_select :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('banzuzuzhang')" required>
            <el-select v-model="yt.editObj.attribute1" filterable>
              <el-option v-for="item in employeeList" :key="item.id" :label="item.name" :value="item.id + ''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shebeifenzu')" required>
            <yi_dictionary_select type="EQUIPMNET_GROUP_NAME_TYPE" :max="999" :ids.sync="yt.editObj.attribute2"> </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button v-if="yt.editObj.action == 'xinzeng'" size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/team/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
          <el-button v-if="yt.editObj.action == 'bianji'" size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/team/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 班组人员 -->
      <template v-else-if="yt.editObj.action == 'banzurenyuan'">
        <div class="dialog-scroller">
          <member ref="member" :team="yt.editObj"></member>
        </div>
      </template>
      <!-- 班组人员导入 -->
      <template v-if="yt.editObj.action == 'daorubanzurenyuan'">
        <div class="dialog-scroller">
          <yi_excel_import ref="teamMemberImport" @loading-start="startLoading" @loading-stop="stopLoading" :templatekey="'team_member_import_template_key'" :uploadApi="'/web/team/member/batchImport'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" :loading="teamMemberImportLoading" @click="teamMemberImportData">{{ $t('baocun') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import member from '@@/pages/web/employment_management/team/member';
import XLSX from 'xlsx';
export default {
  name: 'web_employment_management_team_list',
  components: {
    member
  },
  data() {
    return {
      loading: false,
      exportLoading: false,
      teamMemberImportLoading: false,
      employeeList: [],
      columns: [
        {
          label: 'banzubianhao',
          prop: 'teamNo'
        },
        {
          label: 'banzumingcheng',
          prop: 'teamName'
        },
        {
          label: 'banzuzuzhang',
          prop: 'attribute1',
          type: 'slot'
        },
        {
          label: 'shebeifenzu',
          prop: 'attribute2',
          type: 'dictionary',
          key: 'EQUIPMNET_GROUP_NAME_TYPE'
        },
        {
          label: 'suoshuzuzhi',
          prop: 'org.name'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
    this.http.get('/web/team/listTeamLeader').then(res => {
      this.employeeList = res.data;
    });
  },
  methods: {
    getLeaderName(id) {
      let name = '';
      this.employeeList.filter(item => {
        if (item.id == id) {
          name = item.name;
          return true;
        }
      });
      return name;
    },
    deleteRecord(data) {
      this.loading = true;
      this.http
        .post('web/team/delete', data)
        .then(res => {
          this.$message({
            message: this.$t('success'),
            type: 'success'
          });
          this.yt.get();
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    startLoading() {
      this.teamMemberImportLoading = true;
    },
    stopLoading() {
      this.teamMemberImportLoading = false;
    },
    teamMemberImportData() {
      let data = [...this.$refs.teamMemberImport.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      if (this.$refs.teamMemberImport.listLength == null || this.$refs.teamMemberImport.listLength.length == 0) {
        this.teamMemberImportLoading = true;
        this.http
          .post('/web/team/member/batchImport?onlyValidate=false', data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
          })
          .finally(() => {
            this.teamMemberImportLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },
    exportExcel() {
      this.exportLoading = true;
      //查询表格
      this.http
        .post('/web/team/exportTeamMember', { ...this.yt.conditions })
        .then(res => {
          let tableFirst = [this.$t('banzubianhao'), this.$t('banzumingcheng'), this.$t('gonghao'), this.$t('xingming'), this.$t('banzuzhiwei'), this.$t('shanchubiaoshi')];
          let tableData = [];
          tableData.push(tableFirst);
          let listData = res.data;
          if (listData != null) {
            for (let i = 0; i < listData.length; i++) {
              if (listData[i].teamMemberList != null && listData[i].teamMemberList != undefined && listData[i].teamMemberList.length > 0) {
                for (let j = 0; j < listData[i].teamMemberList.length; j++) {
                  let dataArr = [];
                  let item = listData[i].teamMemberList[j];
                  dataArr[tableFirst.indexOf(this.$t('banzubianhao'))] = listData[i].teamNo;
                  dataArr[tableFirst.indexOf(this.$t('banzumingcheng'))] = listData[i].teamName ? listData[i].teamName : '';
                  dataArr[tableFirst.indexOf(this.$t('gonghao'))] = item.jobNo ? item.jobNo : '';
                  dataArr[tableFirst.indexOf(this.$t('xingming'))] = item.name ? item.name : '';
                  dataArr[tableFirst.indexOf(this.$t('banzuzhiwei'))] = item.teamPosition ? this.$t(this.store.state.dictJson['HR_TEAM_POSITION'][item.teamPosition]) : '';
                  tableData.push(dataArr);
                }
              } else {
                let dataArr = [];
                dataArr[tableFirst.indexOf(this.$t('banzubianhao'))] = listData[i].teamNo;
                dataArr[tableFirst.indexOf(this.$t('banzumingcheng'))] = listData[i].teamName ? listData[i].teamName : '';
                tableData.push(dataArr);
              }
            }
          }
          let worksheet = XLSX.utils.aoa_to_sheet(tableData);
          let workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, `${this.$t('banzurenyuan')}_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
        })
        .finally(() => {
          this.exportLoading = false;
        });
    }
  }
};
</script>

<style scoped></style>
